import React, {useMemo} from "react";
import HighchartsReact from "highcharts-react-official";
import { blue, lightBlue } from '@mui/material/colors'

import {useTranslation} from "react-i18next";
import Highcharts, {chartLogoOptions, creditsOptions, exportingOptions} from "../highChartsBase";
import useHighChartLocaleOptions from "../useHighChartLocaleOptions";
import Stack from "@mui/material/Stack";

const TimeserieHSGraph = ({data, station, highlightedDate}) => {
    const {t} = useTranslation("graphs");
    const highChartLocaleOptions = useHighChartLocaleOptions();

    const options = useMemo(() => {
        const xAxis = {
            type: 'datetime',
            gridLineWidth: 1,
        };

        if (highlightedDate) {
            xAxis.plotLines = [{
                color: 'red',
                value: new Date(highlightedDate).getTime(),
                width: 1,
                dashStyle: 'Dash',
                zIndex: 5,
                label: {
                    text: '',
                    style: {
                        color: 'red',
                        fontWeight: 'bold'
                    }
                }
            }];
        }

        return {
            ...highChartLocaleOptions,
            exporting: {
                ...exportingOptions.exporting,
                filename: `${station?.code ?? 'model1'}_hs`
            },
            title: {
                text: `${station?.code ?? ''} - ${station?.name ?? ''} (${station?.elevation ?? '----'} m)`
            },
            subtitle: {
                text: t('hsGraph.title')
            },
            series: [
                {
                    data: data.map(item => [item.timestamp.getTime(), item.hn ?? null]),
                    type: 'column',
                    name: t('hsGraph.legend.hn'),
                    color: lightBlue[500],
                },
                {
                    data: data.map(item => [item.timestamp.getTime(), item.hs ?? null]),
                    type: 'line',
                    name: t('hsGraph.legend.hs'),
                    color: blue[900],
                    marker: {
                        enabled: true,
                        radius: 3
                    }
                }
            ],
            xAxis: xAxis,
            yAxis: [
            {
                title: {
                    text: 'HS/HN [cm]',
                },
                gridLineWidth: 1
            },
        ],
        tooltip: {
            shared: true,
            crosshairs: true,
            xDateFormat: '%Y-%m-%d %H:%M'
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: true,
                    symbol: 'circle',
                },
                line: {
                    connectNulls: false,
                },
                states: {
                    inactive: {
                        opacity: 1
                    }
                }
            }
        },
        chart: {
            zoomType: 'x',
            height: 500,
            ...chartLogoOptions
        },
        ...creditsOptions,
    };
    }, [data, highChartLocaleOptions, t, highlightedDate]);

    return <Stack>
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    </Stack>
}

export default TimeserieHSGraph;
